  const webProjects = [
    {
      name: 'Cartify',
      description: `The ultimate destination for all your shopping needs`,
      short: 'An E-commerce website built using MERN stack.',
      link:"https://cartify-frontend.vercel.app/",
      stack: [
        'HTML',
        'CSS',
        'JavaScript',
      ]
    },
    {
      name: 'Portfolio',
      description: `A portfolio website to showcase my work`,
      short: 'My portfolio website built using React.js and You are currently viewing it.',
      link:"https://logeshwaran-portfolio-logeshwaran95.vercel.app/",
      stack: [
        'HTML',
        'CSS',
        'JavaScript',
      ]
    },
    {
      name: 'Foody',
      description: 'You can’t stop eating, so go!',
      short: 'A Landing page for a food ordering website called Foody',
      link:"https://logeshwaran95.github.io/Foody-Landing-Page/",
      stack: [
        'HTML',
        'CSS',
        'JavaScript',
      ]
    },
    {
      name: 'Movie Time',
      description: `It's Move Time !`,
      short: 'Movie Time is a movie website that displays movies and their details fetched from backend (static data).',
      link:"https://movie-time-nu.vercel.app/",
      stack: [
        'HTML',
        'CSS',
        'JavaScript',
      ]
    },
    {
      name: 'Glassmorphism Portfolio',
      description: 'Glassmorphism',
      short: 'A portfolio website built utilising the glassmorphim technique',
      link:"https://logeshwaran95.github.io/glassmorphism_portfolio/",
      stack: [
        'HTML',
        'CSS',
        'JavaScript',
      ]
    }
  ]

  const mobileProjects = [
    {
      id:"id1",
      name:"Cine4Life",
      short:"A Movie App",
      link:"https://expo.dev/@logeshsiva/cine4life",
      back:"A fully functioning mobile app that will show all movies and packed with more functionalities !",
      description:"Cine4Life has a catalog of all movies, TV series neatly sorted into categories by genre, like horror, thriller, comedy, etc. Users can also search movies with keywords and find them by year of release. Celebrities and their details are also available in the app. Users can log in with google or email and can customize their profile, add movies or series to their watchlist, favorites, and watched list. Many details are added! so that you cannot miss any details of any movie or series or Celebrities!",
      images : [
            {
              original: "https://i.im.ge/2022/07/10/uvOFaM.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOFaM.th.jpg',
            },
            {
              original: 'https://i.im.ge/2022/07/10/uvOCpS.jpg',
              thumbnail: 'https://i.im.ge/2022/07/10/uvOCpS.th.jpg',
            },
            {
              original: 'https://i.im.ge/2022/07/10/uvOYKF.jpg',
              thumbnail: 'https://i.im.ge/2022/07/10/uvOYKF.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOx1z.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOx1z.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvO3w6.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvO3w6.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOAAy.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOAAy.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOgi9.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOgi9.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOcXK.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOcXK.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOZ7h.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOZ7h.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvO8cX.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvO8cX.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvORG8.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvORG8.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOKCM.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOKCM.th.jpg',
            },
            {
              original:"https://i.im.ge/2022/07/10/uvOVpY.jpg",
              thumbnail: 'https://i.im.ge/2022/07/10/uvOVpY.th.jpg',
            }
          ]
    },
    {
      id:"id2",
      name:"Mediaverse",
      short:"A Social media App",
      back:"A social media app with more interesting features that people love to use!",
      link:"https://expo.dev/@logeshsiva/mediaverse",
      description:"A social networking app that functions similarly to the other daily-used social media apps but adds features from other apps, giving users access to the benefits of all those apps in an one app.",
      images : [
        {
          original:"https://i.im.ge/2022/07/11/unMjof.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/unMjof.th.jpg',
        },
        {
          original:"https://i.im.ge/2022/07/11/uJeDfG.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJeDfG.th.jpg',
        },
        {
          original:"https://i.im.ge/2022/07/11/uJeh8J.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJeh8J.th.jpg',
        },
        {
          original:"https://i.im.ge/2022/07/11/uJe6PK.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJe6PK.th.jpg',
        },
        {
          original:"https://i.im.ge/2022/07/11/uJeLux.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJeLux.th.jpg',
        },
        {
          original: "https://i.im.ge/2022/07/11/uJeU9a.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJeU9a.th.jpg',
        },
      
      
        {
          original:"https://i.im.ge/2022/07/11/uJe7PL.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJe7PL.th.jpg',
        },
       
        {
          original:"https://i.im.ge/2022/07/11/uJe0Qy.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJe0Qy.th.jpg',
        },
        {
          original:"https://i.im.ge/2022/07/11/uJe5LS.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJe5LS.th.jpg',
        },
       
        {
          original:"https://i.im.ge/2022/07/11/uJe9xz.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJe9xz.th.jpg',
        },
        {
          original:"https://i.im.ge/2022/07/11/uJewqF.jpg",
          thumbnail: 'https://i.im.ge/2022/07/11/uJewqF.th.jpg',
        }
      ]
    }
  ]

  export {
    webProjects,
    mobileProjects
  }